<template lang="pug">
extends ../../../../prototype/src/pug/layout/section_column
include ../../../../prototype/src/pug/abstracts/mixin.pug
block main
	include ../../../../prototype/src/pug/abstracts/variables
	.markdown.beneficios__text_block
		include:markdown-it ../../assets/texts/beneficios/main.md

	include ../../../../prototype/src/pug/partials/beneficios/items

	.button__group.beneficios__cta
			a(href="https://loja.spcbrasil.org.br/certificado-digital").button Comprar agora
			a(:href="BASE_URL + 'certificados'").button__text Encontrar modelo ideal	
block variables
	- var id = "beneficios"
</template>

<script>
export default {
	name: "ComprarComponent",
	data: () => {
		return {
			BASE_URL: process.env.BASE_URL,
		};
	},
};
</script>
